export { ResizeSensorComponent } from './resize-sensor.component';
export { ResizeSensorModule } from './resize-sensor.module';



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-resize-sensor/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-resize-sensor/dist/es/main.js
// module chunks = 3